import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

var index = createBrowserOnlyLazyComponent(()=>import('./component-fddefe0c.js'/* webpackChunkName: "dbh.full-page-error-overlay.component" */));

export { index as default };
